<template>
  <vue-modal classes="vue-modal-container"
             height="500px"
             name="city-select-modal"
             width="300px">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('city-select-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <maps-auto-complete @set-position="setPosition"></maps-auto-complete>
    </div>
  </vue-modal>
</template>

<script>
import MapsAutoComplete from '../map/AutoComplete'
import {mapState} from 'vuex'

export default {
  methods: {
    setPosition (position) {
      this.$emit('set-position', position)
      // eslint-disable-next-line
      this.$modal.hide('city-select-modal')
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.citySelectModal,
    }),
  },
  components: {
    MapsAutoComplete,
  },
}
</script>

<style scoped>
</style>
